import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './assets/style.css'
import { useAuthStore } from './stores/auth'
import axios from '@/services/axios'

// Toast Notification
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

// Global components
import BRKLoading from './components/BRKLoading.vue'
import BRKConfirm from './components/BRKConfirm.vue'

// Global utilities
import { decodeHtmlEntities } from './utils/stringUtils'
import { versionChecker } from './utils/versionChecker'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Setup Toast with custom options
app.use(Toast, {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false,
  transition: 'Vue-Toastification__fade',
  maxToasts: 5,
  newestOnTop: true
})

// Register global components
app.component('BRKLoading', BRKLoading)
app.component('BRKConfirm', BRKConfirm)

// Register global properties
app.config.globalProperties.$decodeHtml = decodeHtmlEntities

// Mount app first
app.mount('#app')

// Initialize auth store after router is ready and with a small delay
// This prevents race conditions and reduces concurrent API calls
router.isReady().then(() => {
  setTimeout(() => {
    const authStore = useAuthStore()
    authStore.initializeAuth()
  }, 100)

  // Initialize version checker for auto-update
  versionChecker.init()
})